import { useEffect } from "react";
import { applyAppBrandingToDocument } from "@/utils/appBranding";

export default function AppShellBranding() {
  useEffect(() => {
    applyAppBrandingToDocument();
  }, []);

  return null;
}
